import { captureException } from '../../utils/sentryAPI';
export function isWindowTopLevel() {
  try {
    return window.parent === window.self;
  } catch (e) {
    captureException(e);
    return true;
  }
}